'use client';

import { useState } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import { useInView } from 'src/hooks/use-in-view';

// ----------------------------------------------------------------------

/**
 * 홈 장면이 **화면에 들어왔나** — 한 번 들어오면 굳는다(다시 나가도 안 돌아간다).
 *
 * 🔑 장면은 들어오기 전에도 보이는 상태다 — 이 값은 살짝 떠오르는 움직임과 장면 안 연출(정렬 바꾸기 등)의 신호일 뿐이다.
 * ⚠️ 움직임을 줄이라는 설정(`prefers-reduced-motion`)이면 처음부터 들어온 것으로 본다.
 * @returns `ref` 지켜볼 요소에 거는 콜백 ref · `shown` 들어왔나 · `reduceMotion` 움직임을 줄이라는 설정인가
 */
export function useHomeReveal() {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const seen = useInView(node, { rootMargin: '0px 0px -20% 0px', fallbackMs: 8000 });
  return { ref: setNode, shown: seen || reduceMotion, reduceMotion };
}
